import { Routes, RouterModule } from '@angular/router';
import { ConfirmDeactivateGuard } from 'src/commons/guards';
import { MatchingGiftScreenComponent } from './matching-gift.component';

const matchingGiftRoutes: Routes = [
];

export const MatchingGiftRouter = RouterModule.forChild(matchingGiftRoutes);